<template>
  <div id="shopify-section-template--20801322549474__collection_list_iAQiBH"
    class="shopify-section ui-test-collection-list">
    <div class="section-background color-scheme-1"></div>

    <div class="
    section
    section--page-width
    color-scheme-1
    section-resource-list
    spacing-style
    gap-style
  "
      style="max-width: none;
    --padding-block-start: max(20px, calc(var(--spacing-scale) * 24px));--padding-block-end: 0px;
    --gap: 12px;
  "
      data-testid="collection-list">
      <div class="section-resource-list__content"></div>

      <div class="resource-list force-full-width resource-list__carousel "
        style="--resource-list-column-gap-desktop: 7px;--column-count: 5;--column-count-mobile: 1;--mobile-card-size: 44cqw;"
        data-testid="collections-list-grid">
        <div class="resource-list__carousel"
          style="--gutter-slide-width: var(--util-page-margin-offset); --slide-width-max: 450px;">
          <slideshow-component ref="collectionList"
            class="resource-list__carousel"
            initial-slide="0"
            disabled="false"
            actioned=""
            paused="">
            <slideshow-container ref="slideshowContainer">
              <slideshow-slides tabindex="-1"
                ref="scroller"
                gutters="start end"
                @mousedown="onMouseDragStart"
                @mousemove="onMouseDragMove"
                @mouseup="onMouseDragEnd"
                @mouseleave="onMouseDragEnd"
                @click.capture="onScrollerClickCapture">
                <slideshow-slide v-for="(item, idx) in Categories"
                  :key="item.id || idx"
                  :aria-hidden="false"
                  class="resource-list__slide">
                  <div class="resource-list__item">
                    <div class="collection-card border-style collection-card--image-bg categories__item">
                      <router-link class="collection-card__link"
                        :to="`/goods?categoryName=${item.categoryName}`">
                        <span class="visually-hidden">
                          {{ item.categoryName }}
                        </span>
                      </router-link>
                      <div class="collection-card__inner">
                        <div class="
                                 image-block
                                 resource-image
                                 collection-card__image
                                 spacing-style border-style"
                          style="--border-width: 1px; 
                                 --border-style: none; 
                                 --border-color: rgb(var(--color-border-rgb) / 1.0); 
                                 --border-radius: 0px; ">
                          <img :src="item.goodsImage"
                            :alt="item.categoryName"
                            loading="eager"
                            class="image-block__image"
                            sizes="(min-width: 750px) 20vw, 100vw">
                        </div>

                        <div class="collection-card__content layout-panel-flex--column">
                          <div class="spacing-style text-block">
                            <p>{{ item.categoryName }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </slideshow-slide>
              </slideshow-slides>
            </slideshow-container>
          </slideshow-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeCollectionList',

  props: {
    Categories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 列表拖拽状态：仅处理鼠标，触摸行为沿用浏览器原生滑动
      dragState: {
        isDragging: false,
        startX: 0,
        startScrollLeft: 0,
        moved: false,
        blockClick: false
      }
    }
  },
  mounted() {
    // 鼠标在组件外松开时，同步结束拖拽态，避免状态残留
    this._onWinMouseUp = () => this.onMouseDragEnd()
    window.addEventListener('mouseup', this._onWinMouseUp)
  },
  beforeDestroy() {
    if (this._onWinMouseUp) {
      window.removeEventListener('mouseup', this._onWinMouseUp)
      this._onWinMouseUp = null
    }
  },
  methods: {
    /**
     * 鼠标按下开始拖拽，记录初始坐标和滚动位置
     * @param {MouseEvent} event
     */
    onMouseDragStart(event) {
      if (event.button !== 0) return
      const scroller = this.$refs.scroller
      if (!scroller) return
      this.dragState.isDragging = true
      this.dragState.startX = event.clientX
      this.dragState.startScrollLeft = scroller.scrollLeft
      this.dragState.moved = false
    },
    /**
     * 鼠标移动时按位移更新 scrollLeft，形成拖拽滑动
     * @param {MouseEvent} event
     */
    onMouseDragMove(event) {
      if (!this.dragState.isDragging) return
      const scroller = this.$refs.scroller
      if (!scroller) return
      const deltaX = event.clientX - this.dragState.startX
      if (Math.abs(deltaX) > 4) {
        this.dragState.moved = true
      }
      scroller.scrollLeft = this.dragState.startScrollLeft - deltaX
      if (event.cancelable) {
        event.preventDefault()
      }
    },
    /**
     * 鼠标松开或移出时结束拖拽，并在本次事件循环内屏蔽误点击
     */
    onMouseDragEnd() {
      if (!this.dragState.isDragging) return
      this.dragState.isDragging = false
      if (this.dragState.moved) {
        this.dragState.blockClick = true
        window.setTimeout(() => {
          this.dragState.blockClick = false
        }, 0)
      }
    },
    /**
     * 拖拽后阻止点击穿透，避免误触发卡片跳转
     * @param {MouseEvent} event
     */
    onScrollerClickCapture(event) {
      if (!this.dragState.blockClick) return
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>

<style scoped lang="scss">
.shopify-section {
  padding: 0 40px;
}

.categories__item{
  border: 2px solid hsl(from var(--link-color) h s l / 0.09)!important;
  --horizontal-alignment: flex-start;
  --vertical-alignment: flex-start;
  --background-overlay-color: ;
  --gap: 8px;
}

@media screen and (max-width: 749px) {

  .shopify-section {
    padding: 0 16px;
  }
}
</style>